module.exports = __webpack_public_path__ + "static/media/vegetables.7e4ab8c2.png";